import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RequestTags from '../../components/RequestTags';
import { resolveRequestWorkflow } from '../../state/state';

const RequestDictionariesListItem = ({ code, category, dictionaries }) => {
  if (dictionaries.length === 0) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-dictionaries-list-item">
      <RequestTags code={code} category={category} value={dictionaries} type="dictionaries" />
    </List.Item>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { dictionaries: [] });
  return ({ dictionaries: request.dictionaries || [] });
};

export default connect(mapStateToProps)(RequestDictionariesListItem);
